export function getBookingScrollContainer(element: HTMLElement) {
  return element.closest<HTMLElement>('[data-native-route-page]');
}

/** Offset is measured from the viewport, including any fixed app header. */
export function scrollToBookingElement(element: HTMLElement, offset: number) {
  const container = getBookingScrollContainer(element);
  const containerTop = container?.getBoundingClientRect().top ?? 0;
  const scrollTop = container?.scrollTop ?? window.scrollY;
  const top =
    element.getBoundingClientRect().top +
    scrollTop -
    Math.max(offset, containerTop);
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'instant'
    : 'smooth';

  if (container) container.scrollTo({ top, behavior });
  else window.scrollTo({ top, behavior });
}
